import { reactive } from "vue";

export default {
  state: reactive({
    currentPageByQuizId: {},
  }),
  getCurrentPage(quizId) {
    return this.state.currentPageByQuizId[quizId];
  },
  setCurrentPage(quizId, currentPage) {
    this.state.currentPageByQuizId[quizId] = currentPage;
  },
};
